import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';

import { Close as CloseIcon } from '@material-ui/icons';
import { Dialog as MaterialDialog, Grid, Portal } from '@material-ui/core';
import { palette, Typography } from '@dev/ee-components';

import styled from 'styled-components';

import { getCampaignsStore, SetCampaignCreatorOpen } from '@/store/campaigns/actions';
import { SetToastPortalWrapper } from '@/store/toast/actions';
import { useHistoryBackActionContext } from '@/services/hooks/useHistoryBackAction';
import { RegularCampaign } from './components/RegularCampaign';
import { ABCampaign } from './components/ABCampaign';

const Overlay = styled.div`
    background: ${palette.snow[1]};
    height: 100vh;
`;

const CloseIconContainer = styled.div`
    width: 100%;
    height: 68px;
    svg {
        fill: #718096;
        top: 24px;
        right: 24px;
        position: absolute;
        cursor: pointer;
    }
`;

const ContentContainer = styled.div`
    padding: 0px 16px;
`;

const Wrapper = styled.div`
    display: flex;
    margin-top: 32px;
`;

export const StartCampaignCreator = (): JSX.Element => {
    const dispatch = useDispatch();
    const { t } = useTranslation();
    const historyBackAction = useHistoryBackActionContext();

    const { isCampaignCreatorOpen } = useSelector(getCampaignsStore);


    useEffect(() => {
        if (!isCampaignCreatorOpen) {
            return;
        }
        dispatch(SetToastPortalWrapper(true));
  
        historyBackAction?.pushBackCallback(closeGallery) 
        return () => {
            dispatch(SetToastPortalWrapper(false));
        };
    }, [isCampaignCreatorOpen]);

    const closeGallery = (): boolean => {
        dispatch(SetCampaignCreatorOpen(false, null));
        return true;
    };

    const clickCloseButton = (): void => {
        historyBackAction.popAndExecuteBackCallback();
    };

    return (
        <Portal>
            <MaterialDialog open={isCampaignCreatorOpen} fullScreen>
                <Overlay>
                    <CloseIconContainer>
                        <CloseIcon fontSize="large" onClick={clickCloseButton} />
                    </CloseIconContainer>
                    <ContentContainer>
                        <Grid container justifyContent="center">
                            <Grid item xs={12} sm={12} style={{ maxWidth: 830, paddingBottom: 16 }}>
                                <Typography variant="h1">{t('createnewcampaign')}</Typography>
                                <Wrapper>
                                    <RegularCampaign />
                                    <ABCampaign />
                                </Wrapper>
                            </Grid>
                        </Grid>
                    </ContentContainer>
                </Overlay>
            </MaterialDialog>
        </Portal>
    );
};
